

export function animatedPlaceholder(next: (placeholder: string) => void): () => void {

  const prefix = "Ask Spell to create ";
  const texts = [
    "a product requirements doc for a...",
    "a client proposal for a...",
    "a marketing plan for a...",
    "a sales report for a...",
    "an SOP for a...",
    "an offer letter for a...",
    "a research proposal for a...",
    "an investment memo for a...",
    "an RFP for a...",
    "a competitive analysis for a...",
    "a business plan for a...",
  ]

  let animatedPlaceholder = ""
  let currentTextIndex = 0
  let charIndex = 0
  let typingInterval = null
  let canceled = false
  const startTyping = () => {
    if (canceled) {
      return
    }
    typingInterval = setInterval(() => {
      if (charIndex < texts[currentTextIndex].length) {
        // keep typing
        animatedPlaceholder += texts[currentTextIndex][charIndex]
        next(prefix + animatedPlaceholder)
        charIndex++
      } else {
        // finished typing, pause, then erase
        clearInterval(typingInterval)
        setTimeout(startErasing, 1000) // wait before erasing
      }
    }, 30) // typing speed
  }

  const startErasing = () => {
    if (canceled) {
      return
    }
    typingInterval = setInterval(() => {
      if (charIndex > 0) {
        animatedPlaceholder = animatedPlaceholder.slice(0, -1)
        next(prefix + animatedPlaceholder)
        charIndex--
      } else {
        clearInterval(typingInterval)
        // move to next text
        currentTextIndex = (currentTextIndex + 1) % texts.length
        setTimeout(startTyping, 200) // wait before typing next text
      }
    }, 20) // erasing speed
  }
  startTyping()

  return () => {
    canceled = true
    clearInterval(typingInterval)
  }
}